import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import { Bold, Container, Description, Label, Title, Wrapper } from './GdprConditions.elements';

export interface GdprConditionsProps {}

const GdprConditionsTemplate: FC<GdprConditionsProps> = () => {
    return (
        <Wrapper>
            <Title>ZÁSADY OCHRANY OSOBNÍCH ÚDAJŮ</Title>
            <Container>
                <Label>Informace o zpracování osobních údajů</Label>
                <Description>
                    Poradce Podnikatele, spol. s r.o., jakožto správce osobních údajů, Vás tímto informuje o způsobu a rozsahu zpracování osobních údajů, jakož i plní svoji informační povinnost o Vašich právech v souvislosti se zpracováním osobních údajů v souladu s nařízením Evropského parlamentu a Rady (EU) ze dne 27. dubna 2016 č. 2016/679, o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů a o zrušení směrnice 95/46/ES (dále jen ,,GDPR“).
                </Description>
            </Container>
            <Container>
                <Label>Poradce Podnikatele, spol. s r.o.</Label>
                <Description>
                    IČO: 496 78 876, DIČ: CZ 496 78 876,
                </Description>
                <Description>
                    sídlo: Jablonského 639/4, PSČ: 170 00, Praha 7 - Holešovice
                </Description>
                <Description>
                    zapsaná v obchodním rejstříku vedeném Městským soudem v Praze, oddíl C, vložka 21589
                </Description>
                <Description>
                    dále jen (<strong>“Správce“</strong>)
                </Description>
            </Container>
            <Container>
                <Label>Naše kontaktní údaje</Label>
                <Description>
                    Oprávněná osoba na úseku osobních údajů: Ing. Renáta Mikulíková
                </Description>
                <Description>
                    e-mail: osobniudaje@pp.cz
                </Description>
                <Description>
                    Tel.: +420 737 518 210
                </Description>
                <Description>
                    Ochrana osobních údajů je záležitostí důvěry a my bychom Vás chtěli ujistit, že u nás jsou Vaše osobní údaje v bezpečí. Ochrana a shromažďování, zpracování a používání Vašich osobních údajů v souladu se zákonem jsou pro nás velmi důležité a umožňují nám chránit Vaše soukromí. Máme zavedeny vnitřní systémy a mechanismy pro dostatečné zabezpečení při zpracování osobních údajů.
                </Description>
            </Container>
            <Container>
                <Label>Jaké údaje o Vás shromažďujeme?</Label>
                <Description>
                    Pokud je dán některý z níže uvedených důvodů a účelů, můžeme o Vás shromažďovat tyto identifikační, kontaktní a platební údaje
                </Description>
                <Description>
                    - jméno a příjmení, titul
                </Description>
                <Description>
                    - podpis
                </Description>
                <Description>
                    - adresa bydliště/sídla
                </Description>
                <Description>
                    - adresa elektronické pošty
                </Description>
                <Description>
                    - IČ, DIČ
                </Description>
                <Description>
                    - telefonní číslo
                </Description>
                <Description>
                    - bankovní účet
                </Description>
                <Description>
                    - banka, u níž je účet veden
                </Description>
                <Description>
                    - podobizna
                </Description>
                <Description>
                    - název – obchodní firma, jméno, příjmení
                </Description>
                <Description>
                    - pracovní pozice
                </Description>
                <Description>
                    - provozovna
                </Description>
                <Description>
                    - cookies
                </Description>
                <Description>
                    - data vytvářená uživatelem a data o nákupech (například historie prokliků a návštěv):
                    <ul>
                        <li>korespondence se zákazníkem a zpětná vazba ohledně našich produktů a služeb,</li>
                        <li>informace o interakci zákazníka se společností, t.j. jak využíváte služby, datum a čas přihlášení, datum opuštění služby atd.</li>
                    </ul>
                </Description>
                <Description>
                    Za těmito účely provádíme analýzy následujících oblastí:
                    <ul>
                        <li>používání webových stránek a dalších digitálních kanálů (například navštívených stránek a částí stránek a provedených vyhledávání),</li>
                        <li>historie nákupů a přihlášení,</li>
                        <li>zpětná vazba ohledně našich služeb a produktů a výsledky marketingových studií a studií spokojenosti zákazníků.</li>
                    </ul>
                </Description>
            </Container>
            <Container>
                <Label>Jak jsme získali Vaše osobní údaje?</Label>
                <Description>
                    Vaše osobní údaje jsme získali přímo od Vás či od Vašeho zaměstnavatele, případně z veřejně dostupných registrů a rejstříků, jako je např. portál www.justice.cz, administrativní registr ekonomických subjektů, živnostenský rejstřík.
                </Description>
            </Container>
            <Container>
                <Label>Proč a za jakým účelem shromažďujeme osobní údaje o Vás?</Label>
                <Description>
                    Provádíme zpracování Vašich osobních údajů, neboť je to nezbytné pro splnění smlouvy s Vámi (nebo pro provedení opatření přijatých před uzavřením takové smlouvy), rovněž za účelem Vaší registrace pro užívání našich služeb, zvýšení uživatelské přívětivosti našich produktů a služeb, vylepšení sortimentu našich produktů a služeb, poskytnutí zákazníkům možnosti ovlivnit používaný produkt a související služby. Osobní údaje zpracováváme rovněž pro plnění našich veřejnoprávních povinností.
                </Description>
                <Description>
                    Vaše osobní údaje tedy potřebujeme a zpracováváme za účelem uzavření smlouvy, nákupů, dodání zboží a služeb, jakož i pro realizaci díla a dodání na určené místo, řešení odpovědnosti za vady, komunikaci s Vámi a pro plnění povinností určených zákonem, zejména ve vztahu k archivaci dokumentů a účetnictví. Rovněž některé osobní údaje mohou být vyžadovány za účelem zlepšování kvality našich služeb. Osobní údaje mohou být zpracovávány rovněž pro účely reklamy a propagace, kdy za tímto účelem jsme Vás požádali o udělení souhlasu.
                </Description>
                <Description>
                    Stránky www.studiow.cz využívají služby cookies pro zkvalitnění Vašich služeb. Používáním www.studiow.cz souhlasíte s používaním těchto cookies.
                </Description>
                <Description>
                    Vaše osobní údaje zpracováváme rovněž pro účely případného reklamačního či soudního řízení.
                </Description>
            </Container>
            <Container>
                <Label>
                    Na základě jakého právního titulu (důvodu) zpracováváme Vaše osobní údaje?
                </Label>
                <Description>
                    a) Právním základem pro zpracování osobních údajů je plnění smlouvy, kterou jsme s Vámi uzavřeli nebo chystáme uzavřít.
                </Description>
                <Description>
                    b) Právním základem pro zpracování osobních údajů je plnění zákonné povinnosti, neboť zákony nám ukládají povinnost archivovat některé dokumenty, zejména daňové doklady. Tuto povinnost nám ukládá zejména zákon č. 235/2004 Sb., o dani z přidané hodnoty, ve znění pozdějších předpisů, zákon č. 586/1992 Sb., o daních z příjmů, ve znění pozdějších předpisů, a zákon č. 563/1991 Sb., o účetnictví, ve znění pozdějších předpisů, a zákon č. 499/2004 Sb., zákon o archivnictví a spisové službě a o změně některých zákonů, ve znění pozdějších předpisů.
                </Description>
                <Description>
                    c) Právním základem pro zpracování osobních údajů je po provedeném testu rovnováhy dále náš oprávněný zájem, a to pro vyřízení reklamačního řízení a stížností. Případně též pro účely zasílání reklamních sdělení, pokud jste našim klientem a po provedení testu rovnováhy převáží náš oprávněný zájem. Za tímto účelem jsme Vás zařadili do naší databáze zákazníků a obchodních partnerů. Proti tomuto zpracování můžete podat námitku a okamžitě takového zpracování zanecháme. Osobní údaje rovněž budeme zpracovávat, a to i po skončení smluvního vztahu, pro případné soudní řízení. Proti tomuto zpracování můžete vznést námitku – bližší informace jsou uvedeny na konci tohoto dokumentu,  nezapomeňte si je přečíst!
                </Description>
                <Description>
                    Na základě tohoto titulu tak zpracováváme osobní údaje zejména:
                    <br/>
                    <br/>
                    a. pro ochranu majetku, zdraví a předcházení vzniku škod
                    <br/>
                    <br/>
                    b. rozesílání reklamních sdělení a kontaktování Vás s nabídkou další spolupráce
                    <br/>
                    <br/>
                    c. pro vyřízení reklamačního řízení a stížností
                    <br/>
                    <br/>
                    d. pro zhodnocení Vaší spojenosti s našimi službami
                </Description>
                <Description>
                    d) Právním základem pro zpracování osobních údajů může být i souhlas, například v případě, že bychom chtěli pořizovat fotografie či jinak zpracovávat Vaši podobiznu. Rovněž tehdy, pokud bychom Vás chtěli aktivně oslovit s nabídkou našich služeb a nebyl byste dosud našim klientem.  Souhlas v takovém případě není součástí obchodních podmínek, ale vždy si od Vás případně souhlas vyžádáme samostatně. Pokud jste se přihlásili k odběru obchodních sdělení, informací souvisejících se zbožím a službami, newsletterů/magazínů a pozvánek na propagační akce, pak jste sami udělili tento výslovný souhlas zaškrtnutím políčka před odesláním žádosti o zařazení do databáze. Souhlas můžete kdykoli odvolat na e-mailové adrese uvedené výše, případně písemně na naší adrese uvedené výše. Toto se netýká ukládání souborů cookies. Postup pro odvolání souhlasu s ukládáním souborů cookies najdete v tomto oznámení o ochraně osobních údajů v části týkající se ukládání souborů cookies.
                </Description>
            </Container>
            <Container>
                <Label>Předávání osobních údajů třetím osobám</Label>
                <Description>
                    Osobní údaje jsou, pro zajištění výše popsaných účelů, předávány třetím subjektům a jsou jimi zpracovávány, a to na základě smluv o zpracování osobních údajů uzavřených v souladu s nařízením a zákonem.
                </Description>
                <Description>
                    Zpracovatelem, jiným správcem nebo třetí osobou, kterým jsou osobní údaje předávány a jsou jimi zpracovány, jsou
                    <br/>
                    <br/>
                    - externí advokát
                    <br/>
                    <br/>
                    - účetní kancelář z důvodu zpracování účetnictví
                    <br/>
                    <br/>
                    - IT technik
                    <br/>
                    <br/>
                    - dopravní přepravce pro případné předání a doručení Vaší zásilky
                    <br/>
                    <br/>
                    - společnosti spřízněné, a to: Poradca podnikateľa, spol. s r. o., M. Rázusa 23A, 010 01 Žilina, IČO: 31 592 503
                    <br/>
                    <br/>
                    - AION CS, s.r.o., nám. T. G. Masaryka 1280, 760 01 Zlín, IČO: 60 738 634
                    <br/>
                    <br/>
                    - ESO9 international a.s., Záběhlice, U Mlýna 2305/22, 141 00  Praha 4, IČO: 27 624 609
                </Description>
                <Description>
                    Příjemci Vašich osobních údajů zpracovávaných za účelem plnění povinností vyplývajících z právních předpisů mohou být dále orgány finanční správy, inspektoráty, Policie ČR, soudy či jiné příslušné úřady a orgány státní správy v případech, kdy je nám tato povinnost uložena obecně závaznými právní předpisy.
                </Description>
                <Description>
                    Pověřence pro ochranu osobních údajů nemáme.
                </Description>
            </Container>
            <Container>
                <Label>Jak dlouho si ponecháme Vaše osobní údaje?</Label>
                <Description>
                    Vaše osobní údaje budeme zpracovávat po dobu, po kterou budou trvat účinky práv a povinností ze smlouvy.
                </Description>
                <Description>
                    Po skončení smluvního vztahu budeme zpracovávat Vaše osobní údaje po dobu 4 let z titulu oprávněného zájmu, případně jeden rok po uplynutí promlčení doby, podle toho, která z těchto dob je delší.
                </Description>
                <Description>
                    Pokud nám zákon ukládá povinnost archivovat Vaše osobní údaje po určitou dobu, budou tyto osobní údaje archivovány a uloženy nejdéle po dobu stanovenou v souladu s obecně závaznými právními předpisy.
                </Description>
                <Description>
                    Tam, kde využíváme Vašeho souhlasu, zpracování zanecháme ihned po jeho odvolání.
                </Description>
                <Description>
                    Pro účely rozesílání nabídek zpracováváme Vaší e-mailovou adresu a doručovací údaje. Tyto kontaktní údaje nebudeme nadále zpracovávat za účelem rozesílání reklamního sdělení v případě, že si od nás více jak 4 roky neobjednáte žádnou službu. Nabídku však zasíláme pouze našim klientům, a to z titulu oprávněného zájmu, nebo těm, kdo se přihlásili k odběru novinek na našem webu. Z této rozesílky se můžete kdykoli odhlásit, případně vznést námitku a my obratem rozesílání reklamních sdělení ukončíme.
                </Description>
            </Container>
            <Container>
                <Label>Musíte nám Vaše osobní údaje poskytnout?</Label>
                <Description>
                    Poskytnutí osobních údajů a uzavření smlouvy je dobrovolné, potřebujeme je ale pro uzavření a plnění smlouvy. Rovněž nám i zákon ukládá povinnost zpracovávat Vaše osobní údaje vzhledem k účetním dokladům. Pokud byste nám osobní údaje, jež jsou nezbytné pro uzavření smlouvy a Vaši identifikaci jakožto účastníka smlouvy neposkytli, nemůžeme s Vámi uzavřít smlouvu.
                </Description>
                <Description>
                    Neposkytnutí Vašich osobních údajů v podobě fotografií či osobních údajů za účelem marketingu však nemá vliv na možnost s námi smlouvu uzavřít.
                </Description>
            </Container>
            <Container>
                <Label>Jak se můžete bránit proti zpracování osobních údajů námi?</Label>
                <Description>Pokud nesouhlasíte se zpracováním osobních údajů námi, máte možnost uplatnit Vaše práva, o kterých Vás informujeme níže. Rovněž se kdykoli můžete obrátit se stížností na Úřad pro ochranu osobních údajů se sídlem Pplk. Sochora 27, 170 00, Praha 7, telefon: +420 234 665 111, web: www.uoou.cz, e-mail: posta@uoou.cz.</Description>
                <Description>
                    Zejména máte právo vznést námitku proti zpracování Vašich osobních údajů v případě, pokud je zpracováváme pro náš oprávněný zájem. Osobní údaje po vznesení námitky nezpracováváme, pokud Vám neprokážeme, že naše důvody pro zpracování převažují nad Vašimi důvody, nebo údaje potřebujeme pro určení, výkon nebo obhajobu právních nároků.
                </Description>
                <Description>
                    Pokud vznesete námitku proti zpracování osobních údajů pro účely přímého marketingu, kam spadá i zasílání obchodních sdělení, nebudeme posuzovat naše oprávněné zájmy a Vaše údaje zpracovávat nebudeme.
                </Description>
                <Description>
                    Námitku můžete vznést buď na naší adrese uvedené výše, nebo e-mailem na adrese uvedené výše.
                </Description>
                <Description>
                    Jelikož můžeme Vaše osobní údaje zpracovávat i na základě souhlasu, pokud jste nám jej udělili, máte možnost v případě, pokud nechcete nadále zasílat obchodní sdělení, jako jsou katalogy, zpravodaje a nabídky, souhlas odvolat a tyto obchodní nabídky Vám nebudou zasílány. Souhlas se zpracováním můžete kdykoli bezplatně odvolat na adrese či e-mailu uvedeném výše.
                </Description>
            </Container>
            <Container>
                <Label>Na co všechno máte právo?</Label>
                <Description>
                    <strong>1.      Právo na informace</strong>
                </Description>
                <Description>
                    Vaše hlavní právo je právo na informace, zejména zda, proč a jakým způsobem zpracováváme Vaše osobní údaje. K tomuto slouží tento dokument, který právě čtete. Nedochází u nás k automatizovanému rozhodování. Pokud byste chtěli získat jakékoli další informace, včetně níže uvedených práv, kontaktujte nás na adrese uvedené výše.
                </Description>
                <Description>
                    <strong>2.      Právo na přístup k osobním údajům</strong>
                </Description>
                <Description>
                    Máte právo na přístup k osobním údajům a rovněž sdělení informací, zda a případně za jakým účelem Vaše osobní údaje zpracováváme. O tomto Vám vydáme potvrzení na Vaši žádost. V případě, že chcete využít tohoto práva, kontaktujte nás prosím na adrese uvedené výše.
                </Description>
                <Description>
                    <strong>3.      Právo na opravu</strong>
                </Description>
                <Description>
                    Máte právo na to, abychom opravili bez zbytečného odkladu nepřesné osobní údaje, které se Vás týkají. Za tímto účelem Vás žádáme, abyste si na účetních dokladech, na smlouvách, objednávkách, případně v administraci zkontrolovali Vaše osobní údaje. V případě, že tyto dokumenty nemáte k dispozici či v případě jakýchkoli nesrovnalostí nás prosím kontaktujte na adrese uvedené výše. Obratem Vaše osobní údaje opravíme.
                </Description>
                <Description>
                    <strong>4.      Právo na výmaz (být zapomenut)</strong>
                </Description>
                <Description>
                    Máte právo rovněž na to, abychom vymazali Vaše osobní údaje, pokud:
                    <br/>
                    <br/>
                    - osobní údaje již nejsou potřebné
                    <br/>
                    <br/>
                    - odvoláte svůj souhlas, pokud jste nám jej udělil
                    <br/>
                    <br/>
                    - vznesete námitky proti zpracování
                    <br/>
                    <br/>
                    - osobní údaje zpracováváme protiprávně
                    <br/>
                    <br/>
                    - osobní údaje musí být vymazány ke splnění právní povinnosti
                </Description>
                <Description>
                    <strong>5.      Právo na omezení zpracování</strong>
                </Description>
                <Description>
                    Vaše osobní údaje budeme zpracovávat omezeně, pokud:
                    <br/>
                    <br/>
                    - budete popírat jejich přesnost, a to po dobu potřebnou k ověření přesnosti
                    <br/>
                    <br/>
                    - je zpracováváme protiprávně, nepřejete si jejich výmaz, ale jen omezení jejich použití
                    <br/>
                    <br/>
                    - osobní údaje nepotřebujeme, ale požadujete je pro určení, výkon nebo obhajobu právních nároků
                    <br/>
                    <br/>
                    - vznesete námitku proti zpracování, a to do doby, než bude ověřeno, jestli převažují Vaše nebo naše oprávněné zájmy nad dalším zpracování osobních údajů
                </Description>
                <Description>
                    <strong>6.      Právo na přenositelnost údajů</strong>
                </Description>
                <Description>
                    Právem na přenositelnost údajů se rozumí veškerá Vaše práva obsažená v čl. 20 nařízení, zejména pak právo získat své osobní údaje, které nám byly poskytnuty, ve strukturovaném, běžně používaném a strojově čitelném formátu. Rovněž máte právo nebýt předmětem žádného rozhodnutí založeného výhradně na automatizovaném zpracování.
                </Description>
                <Description>
                    V případě zájmu o přenositelnost nás neváhejte kontaktovat na adrese uvedené výše.
                </Description>
                <Description>
                    <strong>7.      Právo nebýt předmětem automatizovaného rozhodování</strong>
                </Description>
                <Description>
                    Rovněž máte právo nebýt předmětem žádného rozhodnutí založeného výhradně na automatizovaném zpracování. U nás neprobíhá automatizované rozhodování ani profilování.
                </Description>
                <Description>
                    <strong>8.      Právo podat stížnost u dozorového úřadu nebo vznést námitku</strong>
                </Description>
                <Description>
                    Rovněž se kdykoli můžete obrátit se stížností na Úřad pro ochranu osobních údajů se sídlem Pplk. Sochora 27, 170 00, Praha 7, telefon: +420 234 665 111, web: www.uoou.cz, e-mail: posta@uoou.cz.
                </Description>
                <Description>
                    Námitku proti zpracování osobních údajů můžete vznést buď na naší adrese uvedené výše, nebo e-mailem na adrese uvedené výše.
                </Description>
                <Description>
                    <strong>9.      Právo získat informace o porušení zabezpečení Vašich osobních údajů</strong>
                </Description>
                <Description>
                    Je-li pravděpodobné, že následkem porušení našeho zabezpečení bude vysoké riziko pro Vaše práva a svobody, oznámíme Vám toto porušení bez zbytečného odkladu. Pokud se vysoké riziko neprojeví, informace o porušení Vám předávat nemusíme.
                </Description>
                <Description>
                    <strong>10.  Právo odvolat souhlas, pokud ke zpracování dochází na základě souhlasu</strong>
                </Description>
                <Description>
                    Máte právo kdykoliv odvolat souhlas se zpracováním osobních údajů, které jsou námi na základě tohoto souhlasu zpracovávány.
                </Description>
                <Description>
                    Souhlas můžete odvolat na naší adrese uvedené výše, nebo e-mailem na adrese uvedené výše.
                </Description>
            </Container>
            <Container>
                <Label>Remarketing / Retargeting</Label>
                <Description>
                    Pro účely remarketingu shromažďujeme soubory cookies uložené v prohlížeči návštěvníka webu. Soubory cookies obsahují informace o používání webových stránek uložené na pevném disku Vašeho počítače. Jejich účelem je zobrazení a přizpůsobení služeb poskytovaných takovou webovou stránkou při každé Vaší další návštěvě. Cookies také slouží k analýzám provozu na webu, k reklamním a marketingovým účelům.  Používají je téměř všechny webové stránky a pro váš systém nepředstavují žádné nebezpečí. Pokud si chcete zkontrolovat nebo upravit typy souborů cookies, typicky to můžete provést v nastaveních svého prohlížeče.
                </Description>
                <Description>
                    Remarketing či retargeting je zajištěn firmami Google a Seznam a.s. k zobrazování reklam na základě Vašich předchozích návštěv našich stránek. Data z remarketingu používáme výhradně k segmentaci návštěvníků za účelem doručení relevantnějšího reklamního sdělení. Segmenty jsou vytvořeny na základě několika obecných vzorců chování návštěvníků. Komerční sdělení jsou zobrazována ve Vyhledávání Google, Vyhledávací síti Google, v Obsahové síti Google prostřednictvím reklamní sítě Google, ve Vyhledávací síti SEZNAM a.s. a v Obsahové síti Seznam prostřednictvím reklamní sítě Sklik.
                </Description>
            </Container>
            <Container>
                <Label>Google Analytics</Label>
                <Description>
                    Používáme služeb Google Analytics, tedy službu analýzy internetových stránek poskytovanou společností Google, Inc. (Google). Google Analytics je webová analytická služba poskytovaná společností Google. Tato služba využívá soubory cookies k provádění analýz činnosti uživatelů na našem webu. Google tyto informace používá k hodnocení způsobů, kterými využíváte naše webové stránky, k sestavování přehledů činností na webu a poskytování dalších služeb souvisejících s činnostmi na webu a využitím internetu.
                </Description>
                <Description>
                    Google Analytics používá “cookies”, což jsou textové soubory umístěné ve Vašem počítači s cílem pomoci internetové stránce analyzovat, jak ji uživatelé používají. Informace generované pomocí souboru cookies o používání této internetové stránky (včetně IP adresy) budou přeneseny a uloženy společností Google na serverech ve Spojených státech. V případě aktivace anonymizace IP Google zkrátí/anonymizuje poslední oktet IP adresy pro členské státy Evropské unie, jakož i pro ostatní smluvní strany Dohody o Evropském hospodářském prostoru. Pouze ve výjimečných případech je plná IP adresa odeslána a zkrácena servery Google v USA. Jménem provozovatele internetových stránek bude Google používat tyto informace pro účely vyhodnocování užívání stránky, vytváření zpráv o aktivitách internetové stránky pro provozovatele webových stránek a poskytování dalších služeb týkajících se činností na stránce a užívání internetu pro poskytovatele internetových stránek. Google nebude spojovat Vaši IP adresu s žádnými jinými daty Google. Můžete odmítnout používání souborů cookies volbou v příslušném nastavení ve Vašem prohlížeči. Dále můžete zabránit společnosti Google ve shromažďování a využívání údajů (cookies a IP adresy) stažením a instalací plug-inu prohlížeče dostupného na https://tools.google.com/dlpage/gaoptout.. Další informace týkající se podmínek použití a ochrany osobních údajů lze nalézt na http://www.google.com/intl/en/policies/terms nebo na http://www.google.com/intl/en/policies/privacy.
                </Description>
                <Description>
                    Anonymní osobní údaje: zobrazení reklam, analytika, údaje z prohlížeče, údaje o souboru cookies, datum/čas, demografické údaje, typ hardwaru/softwaru, poskytovatel internetových služeb, údaje o interakcích, zobrazení stránek, domény služeb.
                </Description>
                <Description>
                    V rámci Google Analytics jde o trvalý soubor cookies, jehož platnost vyprší za 2 roky. S každou další návštěvou se jeho platnost obnoví na další 2 roky.
                </Description>
            </Container>
            <Container>
                <Label>Google Adwords / Remarketing</Label>
                <Description>
                    Tento soubor cookies nám umožňuje vytvářet, využívat a spravovat digitální reklamu.
                </Description>
                <Description>
                    Anonymní osobní údaje: zobrazení reklam, analytika, údaje z prohlížeče, údaje o souboru cookies, datum/čas, demografické údaje, typ hardwaru/softwaru, poskytovatel internetových služeb, údaje o interakcích, zobrazení stránek, domény služeb.
                </Description>
                <Description>
                    Platnost souborů cookies 2 roky.
                </Description>
            </Container>
            <Container>
                <Label>Sklik / Retargeting</Label>
                <Description>
                    Naše webové stránky využívají technologie retargetingu od služby Sklik provozované společností Seznam.cz, a.s. Ta nám umožňuje ukázat návštěvníkům, kteří již projevili zájem o naše produkty, naše reklamy v reklamní síti společnosti Seznam.cz, a.s. Z cílené reklamy se lze aktuálně odhlásit na adrese http://www.imedia.cz.
                </Description>
                <Description>
                    Tyto služby využíváme pouze za účelem získání statistiky návštěvnosti našich stránek, a za účelem zvyšování návštěvnosti našich webových stránek.
                </Description>
            </Container>
        </Wrapper>
    );
};

export default GdprConditionsTemplate;
